module.exports = __webpack_public_path__ + "img/landing-laptop.e5a461c4.png";